import type { WavespeedModelConfig } from '../../types';
import { clampTo } from '../../../tools';

export const imagenConfigs: Record<string, WavespeedModelConfig> = {
    'google/imagen4-ultra': {
        // https://wavespeed.ai/zh-CN/models/google/imagen4-ultra
        apiPath: '/google/imagen4-ultra',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 可选参数
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                // system
                num_images: 1,
            };
        },
    },
    'google/imagen4': {
        // https://wavespeed.ai/zh-CN/models/google/imagen4
        apiPath: '/google/imagen4',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 可选参数
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                // system
                num_images: 1,
            };
        },
    },
    'google/imagen4-fast': {
        // https://wavespeed.ai/zh-CN/models/google/imagen4-fast
        apiPath: '/google/imagen4-fast',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, aspectRatio, providerOptions } = params;
            return {
                prompt: prompt,
                aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1'] as const, '16:9'),
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // 可选参数
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                // system
                num_images: 1,
            };
        },
    },
};